import * as React from 'react';

import { ProjectsList } from '../../../components/admin/ProjectsList';
import { useSelector } from 'react-redux';
import { selectProjects } from 'shared/selectors/admin/projects';
import { TEditData } from 'shared/components/admin/ProjectsList/ProjectItem';
import { useAppDispatch } from 'shared/hooks';
import { openProjectModal } from 'shared/slices/admin/projectModal';
import { selectLimit } from 'shared/selectors/admin/limit';
import { selectPage } from 'shared/selectors/admin/page';

export const ProjectsListContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const limit = useSelector(selectLimit);
  const page = useSelector(selectPage);

  React.useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const paginationExists = queryParams.has('page') && queryParams.has('limit');

    queryParams.set('page', String(page));
    queryParams.set('limit', String(limit));

    if (paginationExists) {
      window.history.pushState(null, '', `?${queryParams.toString()}`);
    } else {
      window.history.replaceState(null, '', `?${queryParams.toString()}`);
    }
  }, [limit, page]);

  const projects = useSelector(selectProjects);
  const [currentUrl, setCurrentUrl] = React.useState('#');

  React.useEffect(() => {
    const url = new URL(window.location.href);
    url.search = '';
    setCurrentUrl(url.toString().replace(/\/$/, ''));
  }, []);

  /* istanbul ignore next */
  const onProjectClick = React.useCallback(
    (id: number) => {
      window.location.href = `${currentUrl}/${id}`;
    },
    [currentUrl],
  );
  /* istanbul ignore next */
  const onProjectEditClick = React.useCallback(
    (data: TEditData) => {
      dispatch(openProjectModal(data));
    },
    [dispatch],
  );

  return (
    <ProjectsList
      currentUrl={currentUrl}
      projects={projects.list}
      onProjectClick={onProjectClick}
      onProjectEditClick={onProjectEditClick}
    />
  );
};
